export default {
  NoNumbered: 0,
  ToEnd: 1,
  RepeatGroup: 2,
  Serial: 3,
};
